"use strict";

exports.__esModule = true;
exports.default = exports.Comment = exports.Basic = void 0;

var _styledComponents = require("styled-components");

var _styles = require("../styles");

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n    background: white;\n    border: 1px solid ", ";\n    width: 100%;\n    display: inline-block;\n    border-radius: 8px;\n    padding: 0.5em 1.5em;\n    box-sizing: border-box;\n    outline: none;\n    font-size: 16px;\n    line-height: 1.2em;\n    max-height: calc(4em + (0.2em * 4) + 1em);\n    overflow: auto;\n    \n    :empty{\n      display: block;\n    }\n\n    font-size: 14px;\n    color: ", ";\n    letter-spacing: 0;\n\n    &:focus {\n      border: 1px solid ", ";\n    }\n\n    &[placeholder]:empty:before {\n      content: attr(placeholder);\n      color: ", ";\n    }\n\n    & br:last-child {\n      display: none;\n    }\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n    position: relative;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var KineduPalette = _styles.colorPalettes.KineduPalette;
var Basic = {
  wrapper: (0, _styledComponents.css)(_templateObject())
};
exports.Basic = Basic;
var Comment = {
  wrapper: (0, _styledComponents.css)(_templateObject2(), KineduPalette.shadeMedium, KineduPalette.shadeDark, KineduPalette.physical, KineduPalette.shadeMedium)
};
exports.Comment = Comment;
var _default = {
  Basic: Basic,
  Comment: Comment
};
exports.default = _default;